import React, { useEffect, useRef, useState } from "react";
import DragContainer from "../../../elements/dragContainer/dragContainer.container.jsx";
import POICardContent from "./poiCard.content.jsx";
import * as actionMain from "../../../../reduxStore/actions/main.js";
import * as actionInfo from "../../../../reduxStore/actions/infoCard.js";
import * as actionToast from "../../../../reduxStore/actions/toasts.js";
import { connect } from "react-redux";
import * as actionFloor from "../../../../reduxStore/actions/floors.js";
import PropTypes from "prop-types";
import StandardCard from "../../../elements/cards/StandardCard.card.jsx";
import { isMobile } from "react-device-detect";
import { setCurrentAppOverlay } from "../../../../reduxStore/actions/main.js";

/**
 * Dieser Component fährt hoch, wenn man eine der POICards klickt!
 * Er bekommt das currentFeature (Klasse POI) übergeben und zeigt jeweils dessen Properties an
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
function POICard(props) {
  // nur für die Anzeige der EinrichtungsCard
  const currentFeature = useRef(props.currentFeature);
  const [, setSharedItem] = useState(null);
  // falls mal ein Feature nicht ausgewählt ist, dann letztes benutzen bis close animation vorbei
  // und die Card unmounted ist
  if (props.currentFeature) {
    currentFeature.current = props.currentFeature;
  }

  // Dieser Effect ist nur fürs Desktop, damit die Sematik mit dem Close und Closeend richtig angewendet wird
  // weil desktop keine Animationen hat
  useEffect(() => {
    if (isMobile) return;

    props.setStatus(props.currentFeature ? "SET_OPEN" : "CLOSE_FINISH");
  }, [props.currentFeature]);

  //manchmal tritt aus irgendeinem grund dieser fall ein
  if (!props.currentFeature && !currentFeature.current) {
    props.setStatus("CLOSE_FINISH");
    return null;
  }

  if (props.renderInDragContainer) {
    return (
      <>
        <DragContainer
          status={
            props.currentFeature
              ? props.infoCardStatus != null
                ? props.infoCardStatus
                : "preOpen"
              : "close"
          }
          showShadowOnScrolling
          handleCloseEnd={() => props.setStatus("CLOSE_FINISH")}
          handleOpenStart={() => props.setStatus("SET_OPEN")}
          preOpenIsFullScreen
        >
          <div>
            <POICardContent
              poi={currentFeature.current}
              currentChildren={props.currentChildrenPOIs}
              setCurrentFeature={props.setCurrentFeature}
              setFloorNumber={props.setFloorNumber}
              setCurrentAppOverlay={props.setCurrentAppOverlay}
              setSharedItem={setSharedItem}
              isApp={props.isApp}
              setStatus={props.setStatus}
              isTerminal={props.isTerminal}
            />
          </div>
        </DragContainer>
      </>
    );
  } else
    return (
      <StandardCard
        padding={false}
        className={`overflow-auto pointer-event-on ${props.className}`}
      >
        <POICardContent
          poi={currentFeature.current}
          currentChildren={props.currentChildrenPOIs}
          setCurrentFeature={props.setCurrentFeature}
          setFloorNumber={props.setFloorNumber}
          setCurrentAppOverlay={props.setCurrentAppOverlay}
          setSharedItem={setSharedItem}
          isApp={props.isApp}
          isTerminal={props.isTerminal}
          setStatus={props.setStatus}
        />
      </StandardCard>
    );
}
POICard.propTypes = {
  renderInDragContainer: PropTypes.bool,
  setChildrenPOIs: PropTypes.func,
  setFloorNumber: PropTypes.func,
  className: PropTypes.string,
};
POICard.defaultProps = {
  renderInDragContainer: true,
  className: "",
};

const mapStateToProps = (state) => {
  return {
    isApp: state.main.isApp,
    isTerminal: state.main.isTerminal,
    currentFeature: state.main.currentFeature,
    currentChildrenPOIs: state.main.currentChildrenPOIs,
    infoCardStatus: state.infoCard.status,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentFeature: (feature) =>
      dispatch(actionMain.setCurrentFeature(feature)),
    setStatus: (status) => dispatch(actionInfo.setStatus(status)),
    addToast: (toast) => dispatch(actionToast.addToast(toast)),
    setFloorNumber: (floor) =>
      dispatch(actionFloor.setCurrentFloorNumber(floor)),
    setCurrentAppOverlay: (appOverlay) =>
      dispatch(setCurrentAppOverlay(appOverlay)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(POICard);
